"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.default = {
    'onboarding.record.id': 'ID Record',
    'onboarding.record.progress': 'Progresso',
    'onboarding.record.created': 'Creato',
    'onboarding.record.updated': 'Ultimo Aggiornamento',
    'onboarding.record.view': 'Visualizza Dettagli',
    'onboarding.record.continue': 'Continua',
};
